import {
  getApigeeUrl,
  getEnv,
  getRegion,
  ENVS,
  REGIONS,
} from '@adsk/acs-sc-web-platform-api';
import { SUBMITTALS_PERMISSIONS } from '../../constants';
import { getSelectValueLabel } from './utils';

const US_CONFIG = {
  [ENVS.QA]: `${getApigeeUrl()}/submittals-qa`,
  [ENVS.STAGING]: `${getApigeeUrl()}/submittals`,
  [ENVS.PRODUCTION]: `${getApigeeUrl()}/submittals`,
};

const ENV_CONFIGS = {
  [REGIONS.US]: US_CONFIG,
  [REGIONS.EMEA]: US_CONFIG,
  [REGIONS.APAC]: US_CONFIG,
};

export const buildGetSubmittalsPermissionsRequest = (
  projectId,
  memberAutodeskId,
  companyMemberGroupId,
  rolesMemberGroupId
) => {
  const oxygenIds = [
    ...(memberAutodeskId ? [memberAutodeskId] : []),
    ...(companyMemberGroupId ? [companyMemberGroupId] : []),
    ...(rolesMemberGroupId || []),
  ];
  const env = getEnv();
  const region = getRegion();

  return `${
    ENV_CONFIGS[region][env]
  }/v2/projects/${projectId}/settings/mappings?limit=100&filter[oxygenId]=${oxygenIds.join()}`;
};

const getSubmittalsSelectOptions = (T) => [
  {
    value: SUBMITTALS_PERMISSIONS.VIEW,
    label: T.translate('PERMISSIONS.LABELS.VIEW'),
  },
  {
    value: SUBMITTALS_PERMISSIONS.MANAGE,
    label: T.translate('PERMISSIONS.LABELS.MANAGE'),
  },
];

const getSubmittalsInheritanceInfo = (
  companyPermissions,
  rolePermissions,
  selectedCompanyName,
  selectedRoleName,
  T
) => {
  let subjectName = null;
  let subjectType = null;

  if (companyPermissions?.submittalsRole === '1') {
    subjectType = T.translate('PERMISSIONS.TYPES.COMPANY_TEXT');
    subjectName = selectedCompanyName;
  } else if (rolePermissions?.submittalsRole === '1') {
    subjectType = T.translate('PERMISSIONS.TYPES.ROLE_TEXT');
    subjectName = selectedRoleName;
  }

  return T.translate('INHERITED_PERMISSIONS_INFO', {
    subjectType,
    subjectName,
  });
};

export const getSubmittalsPermissionsInfo = (
  memberPermissions,
  companyPermissions,
  rolesPermissions,
  selectedCompany,
  selectedRoles,
  T
) => {
  const selectOptions = getSubmittalsSelectOptions(T);
  const permissions = memberPermissions
    ? memberPermissions.submittalsRole
    : SUBMITTALS_PERMISSIONS.VIEW;
  const rolePermissions = rolesPermissions
    ? rolesPermissions.find(
        (e) => e.submittalsRole === SUBMITTALS_PERMISSIONS.MANAGE
      )
    : null;
  const roleName = rolePermissions
    ? selectedRoles.find((e) => e.memberGroupId === rolePermissions.oxygenId)
        .name
    : null;
  const computedPermissions =
    permissions === SUBMITTALS_PERMISSIONS.VIEW &&
    (companyPermissions?.submittalsRole === SUBMITTALS_PERMISSIONS.MANAGE ||
      !!rolePermissions)
      ? SUBMITTALS_PERMISSIONS.MANAGE
      : null;
  const inheritedPermissions = !!computedPermissions;
  let inheritanceInfo;
  let inheritedPermissionsInfo;
  if (inheritedPermissions) {
    inheritanceInfo = getSubmittalsInheritanceInfo(
      companyPermissions,
      rolePermissions,
      selectedCompany?.name,
      roleName,
      T
    );
    inheritedPermissionsInfo = `${T.translate(
      'ACTUAL_PERMISSION'
    )} ${T.translate('PERMISSIONS.LABELS.MANAGE')}`;
  }
  const selectValue = permissions ? { value: permissions } : undefined;

  return {
    selectValue,
    inheritedPermissionsInfo,
    inheritedPermissions,
    inheritanceInfo,
    selectOptions,
    selectValueLabel: getSelectValueLabel(selectValue, selectOptions),
  };
};
